import { Box, TransportModeSelector } from "src/components";

export default function UserVehicleScreen({ form, setForm }) {
  const handleSelect = (mode) => {
    setForm((prev) => ({ ...prev, transportMode: mode }));
  };

  return (
    <Box sx={{ pb: 3, pt: 3 }}>

        <TransportModeSelector
            value={form.transportMode}
            onChange={(newMode) => handleSelect(newMode)}
        />

    </Box>
  );
}
